// src/components/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children, role }) {
  const { user, loadingAuth } = useAuth();
  const location = useLocation();

  // ✅ DEBUG LOGS
  console.log("[PR] path =", location.pathname, "| roleProp =", role, "| user =", user);

  if (loadingAuth) {
    console.log("[PR] loadingAuth=true -> return null");
    return null;
  }

  if (!user) {
    console.log("[PR] no user -> redirect to /login, from =", location.pathname);
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // ✅ Helper: admin-like roles (matches your backend)
  const roleStr = String(user?.role || "").toLowerCase();
  const isAdminLike =
    roleStr === "admin" ||          // ✅ IMPORTANT: allow old "admin" too
    roleStr === "superadmin" ||
    roleStr === "manager" ||
    roleStr === "ops_supervisor" ||
    roleStr === "lead";

  // ✅ Force password change: block everything except /change-password
  if (user?.must_change_password && location.pathname !== "/change-password") {
    console.log("[PR] must_change_password=1 -> redirect to /change-password");
    return <Navigate to="/change-password" replace state={{ from: location }} />;
  }

  // ✅ If user already changed password, don’t let them stay on change page
  if (!user?.must_change_password && location.pathname === "/change-password") {
    const to = isAdminLike ? "/admin/dashboard" : "/my-schedule";
    console.log("[PR] must_change_password=0 and on /change-password -> redirect to", to);
    return <Navigate to={to} replace />;
  }

  // ✅ if user hits "/" while logged in, redirect by role
  if (location.pathname === "/") {
    const to = isAdminLike ? "/admin/dashboard" : "/my-schedule";
    console.log("[PR] hit / -> redirect to", to);
    return <Navigate to={to} replace />;
  }

  // ✅ role="admin" -> only admin-like
  if (role === "admin" && !isAdminLike) {
    console.log("[PR] admin-only route, user not admin-like -> redirect to /my-schedule");
    return <Navigate to="/my-schedule" replace />;
  }

  // ✅ role="user" -> any logged-in user (including admin-like)
  console.log("[PR] allowed -> render children");
  return children;
}

export default ProtectedRoute;
